import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IReturnPackage {
  id: string | number;
  creatorId: string | number;
  description: string;
  returnWhy: string;
  returnType: string;
  createdAt: string;
  damageType: string;
  packageId: string | number;
  packagePrice: number;
  damageLocation: string;
  productStatus: string;
  conclusionDate: string;
  invoiceNumber: string;
  productGroup: string | number;
  productLocation: string;
  damageDocumentStatus: string;
  damageImages?: string[];
  receiverName?: string;
  rejectionType?: string;
}

export class IReturnPackageListResponse extends IPagination {
  @Type(() => IReturnPackage)
  results: IReturnPackage[];
}

export class IReturnPackageResponse {
  @Type(() => IReturnPackage)
  result: IReturnPackage;
}

export class IPostReturnPackgeBodyDto {
  creatorId: string | number;
  description: string;
  returnWhy: string;
  returnType: string;
  damageType: string;
  packageId: string | number;
  packagePrice: number;
  damageLocation: string;
  productStatus: string;
  invoiceNumber: string;
  productGroup: string | number;
  productLocation: string;
  damageDocumentStatus: string;
  damageImages?: string[];
}

export class IReturnPackageQueryDto extends IQueryPaginationDto {
  packageId?: string;
  description?: string;
  returnWhy?: string;
}
